import { Component, Input } from '@angular/core';

import { statusPretendidoNaoPretendido } from '../../cliente-analise-mercado-status-pretendido';
import { ClienteAnaliseMercadoStatusPretendidoPipe } from '../../pipes';

@Component({
    selector: 'sgt-cliente-analise-mercado-status-pretendido-badge-pill-nao-pretendido',
    templateUrl: './cliente-analise-mercado-status-pretendido-badge-pill-nao-pretendido.component.html',
    styleUrls: ['./cliente-analise-mercado-status-pretendido-badge-pill-nao-pretendido.component.less']
})
export class ClienteAnaliseMercadoStatusPretendidoBadgePillNaoPretendidoComponent {
    /** Title para exibir no badge */
    @Input() title: string = null;

    constructor(private clienteAnaliseMercadoStatusPretendidoPipe: ClienteAnaliseMercadoStatusPretendidoPipe) { }

    /** Retorna o title para exibir no badge */
    getTitle(): string {
        return this.title ? this.title : this.clienteAnaliseMercadoStatusPretendidoPipe.transform(statusPretendidoNaoPretendido.id);
    }
}
